// This file is auto-generated by scripts/set-env.ts
// DO NOT EDIT MANUALLY - changes will be overwritten on build

export const environment = {
  production: true,
  API_URL: "https://api.vengreso.com/romeo/api/",
  STRIPE_KEY: "pk_live_4vsSFhoX32GmuyE6fV1cu9c5",
  EXTENSION_ID: "giidlnpcdhcldhfccdhkaicefhpokghc",
  EXTENSION_ID_TESTING: "mpjnnhbhmhjknjjfccdmndkifkokemdl",
  EDGE_EXTENSION_ID: "mmgiiedikndnbnjnhpgjdgoacimlhdkn",
  OPERA_EXTENSION_ID: "nnbdjajinadfnnandbhdiledclnoacld",
  FRONT_END_URL: "https://app.vengreso.com",
  MAIN_APP_URL: "https://app.vengreso.com",
  ADMIN_APP_URL: "https://admin.vengreso.com",
  CMC_APP_URL: "https://cmc.vengreso.com",
  ROLEPLAY_APP_URL: "https://roleplay.vengreso.com",
  ADMIN_APP_DOMAIN: "https://admin.vengreso.com",
  CMC_APP_DOMAIN: "https://cmc.vengreso.com",
  ROLEPLAY_APP_DOMAIN: "https://roleplay.vengreso.com",
  GOOGLE_CLIENT_ID: "309549483708-003sqr6s6uln0d458vlb5tsl8k8tpl45.apps.googleusercontent.com",
  GOOGLE_DRIVE_API_KEY: "AIzaSyA_qETvKi4WJz-woVqiir_Du6EEFK92ixk",
  GOOGLE_REDIRECT_URI: "flyboard",
  TINYMCE_API_KEY: "o2cs030sqvbkyh0eluohjjsjrze7v7f64hzymgrhdfq0iasu",
  TINYDRIVE_DROPBOX_APP_KEY: "2i010g288jv4fr3",
  GIPHY_API_KEY: "M008YKpaM2Yi4452x0ha1an7ophODy9H",
  GA_MEASUREMENT_ID: "G-9QEH7ZB5FD",
  GA_API_KEY: "JqgShBuFQ62c0s8aPJHFSQ",
  S3_DOMAIN: "flymsg-vengreso.s3-accelerate.amazonaws.com",
  SSO_URL: "https://ondemand-admin.vengreso.com/SSO.ASPX?USERSESSIONID=",
  FLYMSG_DOMAIN: "vengreso.com",
  NODE_API_URL: "https://core.vengreso.com",
};
